export let config = {
    formKey: '566e2acc-e586-41b4-afc6-e1d4a4f4b743',
    weatherKey: 'ddc83cec21a743aab4a91a091b83746f',
    openWeatherKey: 'f36a2ddc5e33d14d3708b92f20f1d315',
    lat: 51.5206777,
    lon: -0.7401434,
    mapId: '15019cba5d15b2ed',
    location: 'Thieves Garden',
    calendarYears: [2025]
}